var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteraction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 37575",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.995,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17564",
    fill: "#185edf",
    d: "M0 0h14v13.995H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37574",
    clipPath: "url(#a)",
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21785",
    d: "M0 5.248a1.886 1.886 0 0 1 .333-.8 1.577 1.577 0 0 1 1.255-.649 104.17 104.17 0 0 1 2.5 0 .545.545 0 1 1 0 1.09H1.724a.561.561 0 0 0-.632.63v2.815a.556.556 0 0 0 .579.63.537.537 0 0 1 .512.54q.006 1.968 0 3.935a.545.545 0 1 1-1.09-.012v-3.266a.26.26 0 0 0-.175-.283 1.592 1.592 0 0 1-.9-1.183l-.026-.117v-3.33"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21786",
    d: "M2.925 0a1.966 1.966 0 0 1 .786.325A1.637 1.637 0 1 1 2.463.024.55.55 0 0 0 2.542 0Zm.354 1.642a.546.546 0 1 0-.552.543.549.549 0 0 0 .552-.543"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21787",
    d: "M11.451 0a1.971 1.971 0 0 1 .786.325 1.637 1.637 0 1 1-1.245-.3.527.527 0 0 0 .077-.025Zm-.2 1.094a.546.546 0 1 0 .55.545.549.549 0 0 0-.55-.545"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21788",
    d: "M11.807 11.472V9.587a.554.554 0 0 1 .57-.624.539.539 0 0 0 .521-.545q.006-1.489 0-2.978a.54.54 0 0 0-.575-.547H9.932a.552.552 0 0 1-.553-.364.545.545 0 0 1 .538-.727q1.229-.006 2.459 0a1.7 1.7 0 0 1 .391.054 1.613 1.613 0 0 1 1.221 1.5 96.264 96.264 0 0 1 0 3.087 1.569 1.569 0 0 1-.98 1.469.159.159 0 0 0-.109.172v3.306a.557.557 0 0 1-.362.568.545.545 0 0 1-.729-.535v-1.954"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21789",
    d: "M7.586 7.106H5.779a.552.552 0 0 1-.554-.363.544.544 0 0 1 .523-.727c.565-.006 1.129 0 1.694 0a.386.386 0 0 0 .169-.029c-.139-.133-.289-.258-.416-.4a.541.541 0 0 1 .3-.9.48.48 0 0 1 .446.113 8.36 8.36 0 0 1 .752.753 1.615 1.615 0 0 1-.144 2.194c-.167.167-.339.33-.512.492a.548.548 0 1 1-.761-.786c.108-.11.208-.227.315-.346"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21790",
    d: "M6.641 11.096c.152.149.275.264.391.385a.547.547 0 1 1-.765.781 11.29 11.29 0 0 1-.578-.58 1.629 1.629 0 0 1 .046-2.289c.183-.183.373-.36.565-.535a.547.547 0 1 1 .752.792c-.112.112-.229.218-.363.345.067 0 .11.008.153.008h1.406a.541.541 0 0 1 .54.45.535.535 0 0 1-.318.589.78.78 0 0 1-.278.05H6.641"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21791",
    d: "M9.621 11.445V9.478a.531.531 0 0 1 .294-.5.516.516 0 0 1 .557.031.56.56 0 0 1 .243.506V13.436a.528.528 0 0 1-.3.5.516.516 0 0 1-.556-.038.555.555 0 0 1-.237-.495v-1.954"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21792",
    d: "M3.28 11.476v-1.94a.531.531 0 0 1 .294-.5.516.516 0 0 1 .557.031.561.561 0 0 1 .242.506v3.88a.541.541 0 0 1-.453.538.535.535 0 0 1-.588-.322.783.783 0 0 1-.048-.279v-1.913"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteraction);
export default __webpack_public_path__ + "static/media/Interaction.58edf36d474bbb7f8c1145c15b3823ce.svg";
export { ForwardRef as ReactComponent };